export const actionTypesEnum = {
    localFormSalvando: 'LOCAL_FORM_SALVANDO',
    loading: 'LOADING',
    getToken: 'GET_TOKEN',
    getEmisor: 'GET_EMISOR',
    getCantones: 'GET_CANTONES',
    getDistritos: 'GET_DISTRITOS',
    getBarrios: 'GET_BARRIOS',
    getErrores: 'GET_ERRORES',
    getNuevoDocumentoErrores: 'GET_NUEVO_DOCUMENTO_ERRORES',
    getActividades: 'GET_ACTIVIDADES',
    getAllActividades: 'GET_ALL_ACTIVIDADES',

    getFacturaPorEmisor: 'GET_FACTURAS_POR_EMISOR',
    getFacturaCompraPorEmisor: 'GET_FACTURAS_COMPRA_POR_EMISOR',
    getNotaCreditoPorEmisor: 'GET_NOTA_CREDITO_POR_EMISOR',
    getNotaDebitoPorEmisor: 'GET_NOTA_DEBITO_POR_EMISOR',
    getTiquetePorEmisor: 'GET_TIQUETE_POR_EMISOR',
    getCabys: 'GET_CABYS',
    getInventario: 'GET_INVENTARIO',
    localForm: 'LOCAL_FORM',
    tipoCambioDolar: 'TIPO_CAMBIO_DOLAR',
    getReceptoresByEmisor: 'RECEPTORES_BY_EMISOR',
    getExoneracion: 'GET_EXONERACION',
    confirmacionFacturas: 'CONFIRMACION_FACTURA',
    getDocumentosConfirmados: 'GET_DOCUMENTOS_CONFIRMADOS',
    searchCabys: 'SEARCH_CABYS',
    duplicarFactura: 'DUPLICAR_FACTURA',
    direccionEmisor: 'DIRECCION_EMISOR',
    direccionReceptor: 'DIRECCION_RECEPTOR',
    estadoDocumentoElectronico: 'ESTADO_DOCUMENTO_ELECTRONICO',
    dashbord: 'DASHBOARD',
    getReceptorHacienda: "GET_RECEPTOR_HACIENDA"
};

export const messageTypeEnum = {
    error: 'ERROR',
    success: 'SUCCESS',
    warning: 'WARNING',
};

export const errorMessageUserEnum = {
    error: 'El usuario se encuentra deshabilitado por favor comunicarse con soporte técnico.',
    activo: "true",
    inActivo: "false"
};

export const docStatusEnum = {
    aceptado: 'ACEPTADO',
    rechazado: 'RECHAZADO',
    error: 'ERROR',
    procesando: 'PROCESANDO',
    AceptadoHacienda: 'APROBADO POR HACIENDA',
};

export const cabysCategoriasEnum = {
    cat1: 'CAT1',
    cat3: 'CAT3',
    cat6: 'CAT6',
    pri: 'PRI',
};

export const documentTypeEnum = {
    Factura: '01',
    NotaDebito: '02',
    NotaCredito: '03',
    Tiquete: '04',
    ConfirmacionAceptacion: '05',
    ConfirmacionParcial: '06',
    ConfirmacionRechazo: '07',
    FacturaCompra: '08',
    FacturaExportacion: '09'
};

export const monedaTypeEnum = {
    Colon: 'CRC',
    Dolar: 'USD',
    Euro: 'EUR',
}

export const tipoImpresionEnum = {
    Carta: 'Carta',
    Tiquete: 'Tiquete'
}

export const estadoConfirmacionEnum = {
    Aceptado: '0',
    Enviado: '1',
    Rechazado: '2',
    Error: '5',
    ErrorReceptor: '6',
    ErrorCedula: '7',
    ErrorFirma: '8'
}

export const mensajeFacturaEnum = {
    Aceptado: 1,
    AceptadoPacial: 2,
    Rechazado: 3

}
export const tipoMenuEnum = {
    Item: '1',
    SubMenu: '2'
};
